import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  CardActions,
  FormGroup,
  FormControlLabel,
  Checkbox
} from "@mui/material";

function CardDownloads(props) {
  const { products } = props;
  const [busqueda, setBusqueda] = useState("Todos");
  const [busquedaProducts, setBusquedaProducts] = useState([]);
  const [busquedaCheckBoxes, setBusquedaCheckBoxes] = useState([]);

  /* UseEffect del filtro en el select */
  useEffect(() => {
    if (busqueda === "Todos") {
      setBusquedaProducts(products);
    } else {
      const filterProducts = products?.filter((p) => (p.title ? p.title === busqueda : ""));
      setBusquedaProducts(filterProducts);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [busqueda, products]);

  /* UseEffect del filtro de los checkboxes */
  useEffect(() => {
    setBusquedaProducts(products);
    const filterProducts = products.filter((product) =>
      busquedaCheckBoxes.length > 0
        ? busquedaCheckBoxes.some((busquedaCheckBox) => product.title.includes(busquedaCheckBox))
        : products
    );
    setBusquedaProducts(filterProducts);
  }, [busquedaCheckBoxes, products]);

  const handleChangeSelect = (event) => {
    const selected = event.target.value;
    setBusqueda(selected);
  };

  const handleChangeCheck = (event) => {
    if (event.target.checked) {
      setBusquedaCheckBoxes([...busquedaCheckBoxes, event.target.value]);
    } else {
      setBusquedaCheckBoxes(
        busquedaCheckBoxes.filter((busquedaCheckBox) => busquedaCheckBox !== event.target.value)
      );
    }
  };

  return (
    <div className="card-downloads">
      <div className="select-none mt-2 mb-3">
        <p className="mt-2 me-2 font-filter">Filtrar por: </p>
        <select
          className="products-select"
          defaultValue="Todos"
          name="products-select"
          onChange={(e) => handleChangeSelect(e)}
        >
          <option value="Todos">Todos</option>
          {products?.map(
            (product, index) =>
              product?.deleted !== true &&
              product?.visible === true &&
              product?.filename.length > 0 && (
                <option key={index} value={product.title}>
                  {product.title}
                </option>
              )
          )}
        </select>
      </div>

      <FormGroup className="products-checkboxes" sx={{ flexDirection: "row" }}>
        {products?.map(
          (product, index) =>
            product?.deleted !== true &&
            product?.visible === true &&
            product?.filename.length > 0 && (
              <FormControlLabel
                className="products-checkboxes__option"
                key={index}
                control={<Checkbox size="small" />}
                label={product.title}
                onChange={handleChangeCheck}
                value={product.title}
              />
            )
        )}
      </FormGroup>

      {busquedaProducts?.map(
        (product, index) =>
          product?.deleted !== true &&
          product?.visible === true &&
          product?.filename.map(
            (file, index) =>
              file?.deleted !== true && (
                <Card sx={{ marginBottom: 3 }} className="card-downloads__card" key={index}>
                  <CardContent key={index} className="cards-style">
                    <div>
                      <img
                        className="img-card-producto"
                        src={product?.imageCarousel[0]?.url}
                        alt={product?.title}
                      />
                      <article className="title-card-archivo">
                        <h4 id="title">
                          {file.title} {product.title}
                        </h4>
                      </article>
                    </div>
                  </CardContent>
                  <CardActions className="actions">
                    <button className="settings_button-pleno bg-p-primary_2 download-file-button">
                      <a href={file.url} target="_blank" rel="noreferrer">
                        Descargar
                      </a>
                    </button>
                  </CardActions>
                </Card>
              )
          )
      )}
    </div>
  );
}

export default CardDownloads;
